import React from 'react';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  'data-id'?: string;
  withGlow?: boolean;
  glowPosition?: 'top-left' | 'bottom-right' | 'both';
}
/**
 * Reusable Section component with consistent dark background and optional glow effects
 * Eliminates repeated background gradient and glow code across components
 *
 * @param withGlow - Add subtle green glow effects
 * @param glowPosition - Position of glow effects (default: 'both')
 *
 * @example
 * <Section withGlow glowPosition="both">
 *   <YourContent />
 * </Section>
 */
export function Section({
  children,
  className = '',
  id,
  'data-id': dataId,
  withGlow = true,
  glowPosition = 'both'
}: SectionProps) {
  return <section id={id} className={`relative w-full bg-gradient-to-b from-[#070707] via-[#0a0a0a] to-[#070707] overflow-hidden ${className}`} data-id="element-2225">
      {/* Subtle background decoration */}
      {withGlow && <div className="absolute inset-0 opacity-30 pointer-events-none" aria-hidden="true" data-id="element-2226">
          {(glowPosition === 'top-left' || glowPosition === 'both') && <div className="absolute top-0 left-1/4 w-96 h-96 bg-[#3ab795] rounded-full blur-[120px] opacity-10" data-id="element-2227" />}
          {(glowPosition === 'bottom-right' || glowPosition === 'both') && <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-[#3ab795] rounded-full blur-[120px] opacity-10" data-id="element-2228" />}
        </div>}

      {/* Content */}
      <div className="relative z-10" data-id="element-2229">{children}</div>
    </section>;
}